module.exports = __webpack_public_path__ + "media/images/xpass/icons/bicycle-66ece06f84e1b4a683f4db377436f8f6.svg";